module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.hasTitle) ? _c('div', {
    staticClass: "form-wrapper-header"
  }, [(_vm.hasIcon) ? _c('div', {
    staticClass: "form-wrapper-icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "size": 22
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "form-wrapper-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper-btns"
  }, [_vm._t("btn")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper-body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90cdb120"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtFormWrapper.vue
// module id = 2201
// module chunks = 137